import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { APP_NAME } from './config/brand'
import { initSentry, maybeTriggerDevSentryTest } from './lib/sentry'

initSentry()
maybeTriggerDevSentryTest()

document.title = `${APP_NAME} — Admin`

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
